export default __webpack_public_path__ + "static/media/home.125a1168.svg";